import { BaseDto } from "src/dtos/common/baseDto";

export interface TqcWorkStandardDto extends BaseDto {
	
	itemCd:			string;		//품목코드
	workplaceCd:	string;		//공정코드
	workplaceNm:	string;		//공정명
	workplaceSeq:	number;		//공정순서
	cycletime:		number;		//사이클타임
	cavity:			number;		//동시생산량
	boxQty:			number;		//박스포장량
	standardSheet:	string;		//작업표준서1
	standardSheet2:	string;		//작업표준서2
	warehouseCd:	string;		//실적입고창고
	warehouseNm:	string;		//실적입고창고명
	remark:			string;		//비고

	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcWorkStandardDto: TqcWorkStandardDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	itemCd: "",
	workplaceCd: "",
	workplaceNm: "",
	workplaceSeq: 1,
	cycletime: 0,
	cavity: 0,
	boxQty: 0,
	standardSheet: "",
	standardSheet2: "",
	warehouseCd: "",
	warehouseNm: "",
	remark: "",

	inserted: false,
	isModified: false,
}
